module.exports = __webpack_public_path__ + "img/b_24.67022548.jpg";